<!--选择excel文件并上传页面-->
<template>
  <div class="import-excel-container">
    <!-- 顶部导航栏 -->
    <el-row class="header-row">
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>

    <!-- 主体内容区域 -->
    <el-row class="main-content">
      <!-- 左侧菜单 -->
      <el-col :span="4" class="left-menu">
        <MenuList></MenuList>
      </el-col>

      <!-- 右侧内容区 -->
      <el-col :span="20" class="right-content">
        <!-- 标题区域 -->
        <div class="title-section">
          <div v-if="form_id" class="page-title">
            <i class="el-icon-upload title-icon"></i>
            <span>往《{{form_name}}》里导入数据</span>
          </div>
          <div v-else class="page-title">
            <i class="el-icon-document-add title-icon"></i>
            <span>手工发布查询</span>
          </div>
        </div>

        <!-- 主要内容卡片 -->
        <div class="content-card">
          <!-- 提示信息区域 -->
          <div class="tips-section">
            <div class="tip-item tip-warning">
              <i class="el-icon-warning-outline tip-icon"></i>
              <span class="tip-text">如果上传失败，请将文件另存为"Microsoft excel 97-2003文件(*.xls)"文件后再上传。</span>
            </div>
            <div class="tip-item tip-danger">
              <i class="el-icon-error-outline tip-icon"></i>
              <div class="tip-content">
                <span class="tip-title">注意：</span>
                <span class="tip-text">1.文件不要超过10M；2.数据之间不要有空行。</span>
              </div>
            </div>
          </div>

          <!-- 上传区域 -->
          <div class="upload-section">
            <el-form ref="editForm" :model="editForm" size="small">
              <el-form-item>
                <el-upload
                  class="upload-demo"
                  :http-request="uploadFile"
                  action
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-change="fileChange"
                  :before-remove="beforeRemove"
                  accept=".xls,.xlsx"
                  multiple
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  drag>
                  <div class="upload-area">
                    <i class="el-icon-upload upload-icon"></i>
                    <div class="upload-text">将文件拖到此处，或</div>
                    <div class="upload-button">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="如果文件大小超过5M,可能传不上去。减小文件大小的方法是：新建一个excel文件,把旧文件中数据复制粘贴到新文件中保存,新文件会变小。可联系客服免费协助解决."
                        placement="top">
                        <el-button type="primary" icon="el-icon-folder-opened">
                          点击上传Excel文件(Office 2007以上版本文件)
                        </el-button>
                      </el-tooltip>
                    </div>
                    <div class="upload-tip">支持 .xls 和 .xlsx 格式文件，文件大小不超过 10M</div>
                  </div>
                </el-upload>

               <!-- <div class="file-actions" v-show="fileList.length > 0">
                  <el-button type="danger" icon="el-icon-delete" @click="emptyFileList" size="small">
                    删除文件
                  </el-button>
                </div> -->
              </el-form-item>

              <!-- 操作按钮区域 -->
              <el-form-item class="action-buttons">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="请不要使用IE浏览器.其他浏览器如果点击无反应,把浏览器切换成'高速模式'后重新登录再试试.切换方法见下方帮助."
                  placement="bottom">
                  <el-button
                    type="primary"
                    @click="uploadExcelFile"
                    icon="el-icon-right"
                    size="medium"
                    class="next-button">
                    下一步
                  </el-button>
                </el-tooltip>
              </el-form-item>

              <!-- 帮助链接区域 -->
              <div class="help-links">
                <el-button @click="howToSwitch" type="text" size="small" class="help-link">
                  <i class="el-icon-question"></i>
                  如何将浏览器切换成"高速模式"或"快速模式"
                </el-button>
<!--                <div class="support-link">
                  <el-link
                    type="danger"
                    href="javascript:window.open('http://wpa.qq.com/msgrd?v=3&uin=34424698&site=qq&menu=yes', '_brank')"
                    target="_blank"
                    icon="el-icon-service">
                    点我寻求客服QQ远程支持
                  </el-link>
                </div> -->
              </div>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 浏览器模式切换对话框 -->
    <el-dialog
      width="70%"
      :close-on-click-modal="false"
      title="如何切换浏览器的模式"
      :visible.sync="browserSwitchDialogVisible"
      class="help-dialog">
      <div class="dialog-content">
        <div class="step-section">
          <div class="step-title">
            <i class="el-icon-warning step-icon"></i>
            操作步骤：
          </div>
          <div class="step-text">
            如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
          </div>
          <div class="dialog-image">
            <img src="../assets/switch_browser.png" alt="切换浏览器模式" />
          </div>
        </div>
        <div class="step-section">
          <div class="step-title">
            <i class="el-icon-success step-icon"></i>
            正确的模式：
          </div>
          <div class="dialog-image">
            <img src="../assets/good_browser.png" alt="正确的浏览器模式" />
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="browserSwitchDialogVisible=false" type="primary" class="confirm-btn">
          我知道了
        </el-button>
      </div>
    </el-dialog>

    <!-- 表格检查对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="表格不能有合并的单元格"
      :visible.sync="checkFormDialogVisible"
      class="check-form-dialog">
      <div class="dialog-content">
        <div class="warning-block">
          <i class="el-icon-warning-outline warning-icon"></i>
          <div class="warning-content">
            <div class="warning-title">重要提示</div>
            <div class="warning-text">
              为了方便核查数据，以及减少导入过程中出错的可能性，请将表格中合并单元格全部取消掉后再导入。
            </div>
            <div class="warning-text warning-highlight">
              取消所有合并单元格的方法是：选中单元格，点"合并单元"取消合并的单元格,取消后如果有空白单元格请填充好数据，方便后期确认数据。
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkFormDialogVisible=false" type="primary" class="confirm-btn">
          知道了
        </el-button>
      </div>
    </el-dialog>

    <!-- 导入必读对话框 -->
    <el-dialog
      :close-on-click-modal="false"
      v-dialogDrag
      title="表格导入必读"
      :visible.sync="mustReadDialogVisible"
      width="60%"
      class="must-read-dialog">
      <div class="dialog-content">
        <div class="qa-list">
          <div class="qa-item">
            <div class="qa-question">
              <i class="el-icon-question question-icon"></i>
              <span>适合导入什么样的表格？</span>
            </div>
            <div class="qa-answer">
              <i class="el-icon-answer answer-icon"></i>
              <span>适合导入首行水平是表头，每行是填表人需要填写数据的表格；如果是复杂表格，请自行设计成首行是表头的表格后再导入。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <i class="el-icon-question question-icon"></i>
              <span>在什么情况下使用导入表格功能？</span>
            </div>
            <div class="qa-answer">
              <i class="el-icon-answer answer-icon"></i>
              <span>一种情况是您有表格，手机端制作录入麻烦，可以用导入；另外一种情况是需要填表人修改您excel表格里的数据，比如修订已有数据。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <i class="el-icon-question question-icon"></i>
              <span>在什么情况导入空表？</span>
            </div>
            <div class="qa-answer">
              <i class="el-icon-answer answer-icon"></i>
              <span>需要填表人填表时导入空表。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <i class="el-icon-question question-icon"></i>
              <span>在什么情况导入数据？</span>
            </div>
            <div class="qa-answer">
              <i class="el-icon-answer answer-icon"></i>
              <span>需要填表人修改您excel表格上的数据时导入数据。</span>
            </div>
          </div>

          <div class="qa-item">
            <div class="qa-question">
              <i class="el-icon-question question-icon"></i>
              <span>表头特别复杂怎么导入？</span>
            </div>
            <div class="qa-answer">
              <i class="el-icon-answer answer-icon"></i>
              <span>导入表格要观察列，因为一个列是一个数据，所以这个列叫什么就给这个列取什么名字。列名可以在预览界面点击单元格选择,可以减少输入量。</span>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="mustReadDialogVisible=false" type="primary" class="confirm-btn">
          知道了
        </el-button>
      </div>
    </el-dialog>

    <!-- 上传失败对话框 -->
    <el-dialog
      width="55%"
      :close-on-click-modal="false"
      title="上传Excel文件失败"
      :visible.sync="uploadFailDialogVisible"
      class="fail-dialog">
      <div class="dialog-content">
        <div class="error-block">
          <i class="el-icon-error error-icon"></i>
          <div class="error-content">
            <div class="error-title">上传文件失败！</div>
            <div class="error-text">
              请检查Excel文件大小是否超过5M，如果Excel文件大小超过5M且表中的数据又不多，说明Excel文件中存在大量的空行或空列。
            </div>
            <div class="error-solution">
              <span class="solution-title">修复方法：</span>
              <span>新建一个Excel文件，将原表格中的数据(只选数据，不是全选)粘贴到新Excel文件中保存后重新上传。如果仍然无法解决，请联系客服帮您处理。</span>
            </div>
          </div>
        </div>
        <div class="contact-info">
          <div class="contact-item">
            <i class="el-icon-message"></i>
            <span>客服微信：wx34424698</span>
          </div>
          <div class="contact-item">
            <i class="el-icon-phone"></i>
            <span>紧急电话：19909408114</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadFailDialogVisible=false" type="primary" class="confirm-btn">
          知道了
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        browserSwitchDialogVisible: false,
        fileList: [],
        courses: [],
        file: '',
        editForm: {
          id: '',
          exam: '',
          course: '',
          grade: '',
          paper_score: ''
        },

        checkFormDialogVisible: false,
        mustReadDialogVisible: false,

        form_id: '',
        form_name: '',

        uploadFailDialogVisible: false
      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
      // console.log('调用exam_list created')
      // this.loadCourses()
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

       // console.log('dddddddddddd',this.form_id,this.form_name)
    },
    methods: {
      handleRemove(file, fileList) {
        this.fileList = []
      },
      handlePreview(file) {},
      uploadFile(file) {
        // this.data.append('file', file.file)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`请先删除原来上传的文件后再上传!`)
        return true
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`)
      },
      uploadExcelFile() {
        if (this.fileList.length === 0) {
          this.$message.error('请上传excel文件！')
          return
        }

        let that = this

        let data = new FormData()
        data.set('username', this.username)

        let tmpExcelFile = this.fileList[0].raw

        // console.log(tmpExcelFile)

        data.append('file', tmpExcelFile)
        data.append('form_id', this.form_id)
        data.append('form_name', this.form_name)


        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/wansearch/web/_upload_data_excel_for_preview.jsp'
        this.axios.post(requestUrl, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          console.log('数据导入完成！！')

          console.log('ssssssssssss',res.data)

          if (res.data.result == '1') {
            // that.$message.success('成功')
            var uploaded_excel_file_name = res.data.excel_file
            that.$router.push({
                name: 'excel_data_preview',
                params: {
                  username: that.username,
                  excel_file: uploaded_excel_file_name,
                  form_id:that.form_id,
                  form_name:that.form_name
                }
              })

              // .checkFormDialogVisible = true
            // that.$message.error('失败啦')
          }else{
            that.uploadFailDialogVisible = true
          }


          load.close()
        }).catch(err => {
          console.log('数据导入异常！！')
          console.log(err)
          load.close()

          that.uploadFailDialogVisible = true
        })
      },

      fileChange(file, fileList) {
        this.fileList = fileList
        console.log(fileList)
        return true
      },
      back() {
        this.$router.push('/validation_form_list')
      },
      emptyFileList() {
        this.fileList = []
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      showUse() {
        this.mustReadDialogVisible = true
      }

    }
  }
</script>

<style scoped>
/* ==================== 页面容器 ==================== */
.import-excel-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
}

/* ==================== 头部区域 ==================== */
.header-row {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

/* ==================== 主体内容区域 ==================== */
.main-content {
  padding: 20px;
}

.left-menu {
  padding-right: 15px;
}

.right-content {
  padding: 0 15px;
}

/* ==================== 标题区域 ==================== */
.title-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 18px 22px;
  margin-bottom: 20px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

.title-icon {
  font-size: 22px;
}

/* ==================== 内容卡片 ==================== */
.content-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px 22px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* ==================== 提示信息区域 ==================== */
.tips-section {
  margin-bottom: 20px;
}

.tip-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.tip-item:last-child {
  margin-bottom: 0;
}

.tip-warning {
  background: #fffbe6;
  border-left: 4px solid #faad14;
}

.tip-danger {
  background: #fff2f0;
  border-left: 4px solid #ff4d4f;
}

.tip-icon {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 1px;
}

.tip-warning .tip-icon {
  color: #faad14;
}

.tip-danger .tip-icon {
  color: #ff4d4f;
}

.tip-content {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.tip-title {
  font-weight: 600;
  color: #ff4d4f;
  font-size: 13px;
}

.tip-text {
  color: #595959;
  font-size: 12px;
  line-height: 1.5;
  flex: 1;
}

/* ==================== 上传区域 ==================== */
.upload-section {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-demo >>> .el-upload-dragger {
  width: 100%;
  height: 250px;
  border-radius: 12px;
  border: 2px dashed #d9d9d9;
  background: #fafafa;
  transition: all 0.3s ease;
}

.upload-demo >>> .el-upload-dragger:hover {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.02);
}

.upload-demo >>> .el-upload-dragger.is-dragover {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}

.upload-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 10px 15px;
  box-sizing: border-box;
}

.upload-icon {
  font-size: 32px;
  color: #adb5bd;
  margin-bottom: 6px;
  transition: all 0.3s ease;
}

.upload-demo:hover .upload-icon {
  color: #667eea;
  transform: scale(1.1);
}

.upload-text {
  font-size: 11px;
  color: #6c757d;
  margin-bottom: 6px;
}

.upload-button {
  margin-bottom: 4px;
}

.upload-button >>> .el-button {
  font-size: 11px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.upload-button >>> .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.upload-tip {
  font-size: 9px;
  color: #adb5bd;
  text-align: center;
  margin-top: 0;
  padding: 0 5px;
  line-height: 1.2;
}

/* ==================== 文件操作按钮 ==================== */
.file-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.file-actions >>> .el-button {
  font-size: 14px;
  padding: 10px 24px;
  border-radius: 6px;
}

/* ==================== 操作按钮区域 ==================== */
.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.next-button {
  font-size: 16px;
  font-weight: 600;
  padding: 14px 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.next-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.next-button:active {
  transform: translateY(0);
}

/* ==================== 帮助链接区域 ==================== */
.help-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-top: 25px;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.help-link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #667eea;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.help-link:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #764ba2;
}

.help-link i {
  font-size: 16px;
}

.support-link {
  margin-top: 5px;
}

.support-link >>> .el-link {
  font-size: 15px;
  font-weight: 500;
}

/* ==================== 对话框通用样式 ==================== */
.help-dialog >>> .el-dialog,
.check-form-dialog >>> .el-dialog,
.must-read-dialog >>> .el-dialog,
.fail-dialog >>> .el-dialog {
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.help-dialog >>> .el-dialog__header,
.check-form-dialog >>> .el-dialog__header,
.must-read-dialog >>> .el-dialog__header,
.fail-dialog >>> .el-dialog__header {
  padding: 20px 20px 15px 20px;
  border-bottom: 1px solid #f0f0f0;
}

.help-dialog >>> .el-dialog__title,
.check-form-dialog >>> .el-dialog__title,
.must-read-dialog >>> .el-dialog__title,
.fail-dialog >>> .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.help-dialog >>> .el-dialog__body,
.check-form-dialog >>> .el-dialog__body,
.must-read-dialog >>> .el-dialog__body,
.fail-dialog >>> .el-dialog__body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.dialog-footer {
  padding: 15px 20px 20px 20px;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.confirm-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 10px 32px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.confirm-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* ==================== 帮助对话框样式 ==================== */
.step-section {
  margin-bottom: 25px;
}

.step-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
}

.step-icon {
  font-size: 20px;
  color: #667eea;
}

.step-icon.el-icon-warning {
  color: #ffa940;
}

.step-icon.el-icon-success {
  color: #27ae60;
}

.step-text {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.6;
  padding-left: 28px;
}

.dialog-image {
  margin-top: 15px;
  text-align: center;
}

.dialog-image img {
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* ==================== 检查表单对话框样式 ==================== */
.warning-block {
  display: flex;
  gap: 15px;
  background: linear-gradient(135deg, #fff7e6 0%, #ffe8cc 100%);
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #ffa940;
}

.warning-icon {
  font-size: 32px;
  color: #ffa940;
  flex-shrink: 0;
}

.warning-content {
  flex: 1;
}

.warning-title {
  font-size: 18px;
  font-weight: 600;
  color: #d46b08;
  margin-bottom: 12px;
}

.warning-text {
  font-size: 14px;
  color: #495057;
  line-height: 1.8;
  margin-bottom: 10px;
}

.warning-highlight {
  font-weight: 500;
  color: #d46b08;
}

/* ==================== 必读对话框样式 ==================== */
.qa-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.qa-item {
  background: #f8f9fa;
  padding: 18px;
  border-radius: 8px;
  border-left: 3px solid #667eea;
}

.qa-question {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
}

.question-icon {
  font-size: 20px;
  color: #667eea;
}

.qa-answer {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: #4a5568;
  line-height: 1.8;
  padding-left: 30px;
}

.answer-icon {
  font-size: 18px;
  color: #27ae60;
  flex-shrink: 0;
  margin-top: 2px;
}

/* ==================== 失败对话框样式 ==================== */
.error-block {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
}

.error-icon {
  font-size: 48px;
  color: #ff4d4f;
  flex-shrink: 0;
}

.error-content {
  flex: 1;
}

.error-title {
  font-size: 18px;
  font-weight: 600;
  color: #d32f2f;
  margin-bottom: 12px;
}

.error-text {
  font-size: 14px;
  color: #495057;
  line-height: 1.8;
  margin-bottom: 12px;
}

.error-solution {
  font-size: 14px;
  line-height: 1.8;
  padding: 12px;
  background: #fff7e6;
  border-radius: 6px;
  border-left: 3px solid #ffa940;
}

.solution-title {
  font-weight: 600;
  color: #d46b08;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #4a5568;
}

.contact-item i {
  font-size: 18px;
  color: #667eea;
}

/* ==================== 响应式设计 ==================== */
@media (max-width: 1200px) {
  .main-content {
    padding: 15px;
  }

  .title-section,
  .content-card {
    padding: 15px 18px;
  }
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
    padding: 10px;
  }

  .left-menu {
    display: none;
  }

  .right-content {
    padding: 0;
  }

  .title-section,
  .content-card {
    padding: 12px 15px;
    border-radius: 10px;
  }

  .page-title {
    font-size: 15px;
    gap: 6px;
  }

  .title-icon {
    font-size: 18px;
  }

  .upload-demo >>> .el-upload-dragger {
    height: 280px;
  }

  .upload-icon {
    font-size: 48px;
  }

  .upload-button >>> .el-button {
    font-size: 13px;
    padding: 10px 20px;
  }

  .next-button {
    width: 100%;
    padding: 12px 24px;
  }

  .qa-item {
    padding: 15px;
  }

  .error-block {
    flex-direction: column;
  }

  .error-icon {
    align-self: center;
    font-size: 40px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 16px;
  }

  .title-icon {
    font-size: 24px;
  }

  .upload-demo >>> .el-upload-dragger {
    height: 250px;
  }

  .upload-area {
    padding: 30px;
  }

  .upload-icon {
    font-size: 50px;
  }

  .upload-text {
    font-size: 14px;
  }

  .upload-button >>> .el-button {
    font-size: 13px;
    padding: 10px 20px;
  }

  .upload-tip {
    font-size: 12px;
  }

  .tip-item {
    flex-direction: column;
    padding: 12px;
  }

  .help-links {
    padding: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/import_data_excel.vue